import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import * as S from './menu-options.styles'
import type { MenuOptionsProps } from "./types";

export const MenuOptions = ({ icon, label, url, customIconSize = 1, onClose }: MenuOptionsProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(url);
    onClose?.();
  };

  return (
    <S.OptionButton onClick={handleClick} aria-label={`Navegar para ${label}`}>
      <S.IconWrapper $customIconSize={customIconSize}>
        <FontAwesomeIcon icon={icon} />
      </S.IconWrapper>
      <span>{label}</span>
    </S.OptionButton>
  );
};
